import { createReducer, on } from '@ngrx/store';
import { setConfiguration } from './configuration.actions';
import { ConfigurationConfig } from '@/app/_core/domain/models/configuration/configuration.model';

export interface ConfigurationState {
  configuration: ConfigurationConfig;
}

export const initialConfigurationState: ConfigurationState = {
  configuration: null
};

export const reducer = createReducer<ConfigurationState>(
  initialConfigurationState,
  on(setConfiguration, (state, action) => ({
    ...state,
    configuration: action.payload.configuration
  }))
);
